<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="container">
     
        <div *ngIf="IsEgwpUserTraining">
            <div class="row" *ngIf="ErrorMessage || showErrors">
                <div class="col-24">
                    <div class="alert danger">
                        <p><em>Error Message:</em></p>
                        <p>There were errors with your submission, including:</p>
                        <p innerHTML="{{ErrorMessage}}"></p>
                    </div>
                </div>
            </div>
            <div *ngIf="!hideStepTwo">

                <div class="row">
                    <div class="col-24">
                        <div class="bottom-20 bold-font">
                            If you'd like to enter a single enrollment you can use the <a #singleEnrollmentLink
                                                                                          href="#"
                                                                                          tabindex="0"
                                                                                          (click)="NavigateURL(); $event.preventDefault()">Single Group Enrollment Online Form</a>.
                        </div>
                    </div>
                </div>
                <div  *ngIf="IsSSI">
                    <div class="row">
                        <div class="col-24">
                            <div class="alert info">
                                <ul>
                                    <li class="update-info" *ngIf="!visibleFrom2025">
                                        The Excel Template has been updated on 09/30/2023.
                                        Please verify that you are using the latest version.
                                    </li>
                                    <li class="update-info" *ngIf="visibleFrom2025">
                                        The Excel Template has been updated on 10/01/2025.
                                        Please verify that you are using the latest version.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-24">
                            <div class="partition">
                                <h2 class="head2-small"> Step 1 - Download the Template </h2>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-16">
                            <div class="bottom-20">
                                <p>Use the template below to upload group enrollments.</p>
                                <p>Required fields are in <strong>BOLD</strong></p>
                                <p>If an Authorized Representative name is entered, then all of the Authorized Representative fields will be required.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-16">
                            <div class="bottom-20">
                                <button class="button primary" (click)="downlaodExcelTemplate()">
                                    Download Group Enrollment Template
                                </button>

                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-16">
                            <div class="bottom-20">
                                <p><strong>NOTE:</strong></p>
                                <ul class="notes-list bottom-10">
                                    <li>The Authorized Representative is <strong>NOT</strong> the Insurance Agent; it is a person who has the Power of Attorney for the Applicant.</li>
                                    <li>Please consult the comments in each of the Columns within the Template for more information.</li>
                                    <li>Please do <strong>NOT</strong> change the Worksheet or Column names within the Template. Doing so will result in an error and we will not be able to process your file.</li>
                                    <li>The Worksheet <strong>MUST</strong> be named "Data" in order for your file to be processed correctly.</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-24">
                            <div class="partition">
                                <h2 class="head2-small"> Step 2 - Upload your File </h2>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-16">
                            <div class="upload-wrapper">
                                <div class="choose-file-wrapper wide">
                                    <button id="yourBtn" class="button secondary" (click)="getFile()">Choose</button>
                                </div>
                                <div class="file-input-hidden"><input #fileInput id="upfile" type="file" name="file" ng2FileSelect [uploader]="uploader" (change)="sub(this)" /></div>
                                <div class="file-name-sec">
                                    <p *ngIf="!FileName">No file choosen</p><p *ngIf="FileName">{{FileName}}</p>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-16">
                            <div class="bottom-20">

                                <p>Please upload your file in <strong>Excel format only</strong>.</p>

                                <p>Once your file has been uploaded, you’ll immediately receive a list of any errors or missing data that is required. Please fix these errors and upload your file again.</p>

                                <p>If your file has been received successfully, you will receive a notification and be given a list of the Applicant's confirmation numbers. You will have the option to save these as a Text file if you chose to do so.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-16">
                            <div class="bottom-20">
                                <p><strong>NOTE:</strong></p>
                                <ul class="notes-list bottom-10">
                                    <li>If you do receive any errors, then none of your enrollments have been processed.</li>
                                    <li>You must submit an error-free file for the records to be processed successfully.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-24">
                            <button id="uplaod" class="button primary" (click)="uploadButtonClick()" [disabled]="!uploader.getNotUploadedItems().length" role="button" aria-label="upload">Upload File</button>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="hideStepTwo">
                <button #focusableEleSuccess class="focusable-element"></button>
                <div class="row">
                    <div class="col-24">
                        <div class="alert success">
                            <p><em>Thank you!</em></p>
                            <p innerHTML="{{SuccessMessage}}"></p>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-24">
                        <button id="save" class="button primary" (click)="saveDetails()">Save Confirmations</button>
                        <button id="uploadAnother" class="button primary" (click)="refresh()">Upload Another File</button>
                    </div>
                </div>
            </div>

            <div class="row" *ngIf="IsSSI">
                <div class="col-24">
                    <p>If you have any question or are experiencing difficulties, please contact us at <a href="mailto:agentsupport@CVScaremark.com">agentsupport&#64;CVScaremark.com</a>. </p>
                </div>
            </div>

        </div>
   
    <div class="row" *ngIf="!IsEgwpUserTraining">
        <div class="col-24">
            <p class="bottom-20"><strong>Note:</strong> Your access to the Enrollment Center is temporarily denied for the following reason(s):</p>
            <!--<p class="bottom-10">You have not completed the {{planyear}} certification training course. To access Enrollment Center, you must first complete the <a class="link" (click)="GetTrainingURL()" class="link-button" target='_blank'>Online Training  </a>.</p>-->
            <p *ngIf="trainingMsg" class="bottom-10">
                You have not completed the necessary certification training course.<br />
                For additional information on training, please visit the <a (click)="GetTrainingURL()">Training and Certification</a> page.
            </p>
        </div>
    </div>
</div>
